import { AuthenticatedLayout } from "../../../../layouts";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { RolesSetup } from "../../../../components/RoleManagement/Roles/RolesSetup";

export const RolesSetupPage = () => {
  return (
    <AuthenticatedLayout
      pageTitle="Roles Setup"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[]}
      mainContents={<RolesSetup />}
    />
  );
};
